// extracted by mini-css-extract-plugin
module.exports = {"infoMessage":"InfoMessage_infoMessage__WzdVM","warning":"InfoMessage_warning__S8KAV","icon":"InfoMessage_icon__i_LVA"};